import { css, keyframes } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

const placeholderAnimation = keyframes({
  "0%": {
    opacity: 0.5,
  },
  "50%": {
    opacity: 1,
  },
  "100%": {
    opacity: 0.5,
  },
});

export const loadingCss = css({
  ...fontSize(14),
  lineHeight: 1,
  borderRadius: tokens.borderRadius.primary.value,
  backgroundColor: tokens.color.gray[300].value,
  animation: `${placeholderAnimation} 1.5s infinite`,
});
